const theme = {
    orgColors: {
        darkOrange: "#e26b27",
        mediumOrange: "#f3c1a5",
        lightOrange: "#fdf5f0",
        darkGray: "#2C2E2F",
        mediumGray: "#babfc3",
        lightGray: "#e2e4e5",
        darkYellow: "#ffc600",
        mediumYellow: "#fee382",
        lightYellow: "#fef0b8",
    },
    typography: {
        allVariants: {
            color: "#2C2E2F",
        },
        body1: {
            color: "#2C2E2F",
        },
        body2: {
            color: "#2C2E2F",
        },
    },
    palette: {
        type: "orgSpecific",
        org: "Datascan",
        primary: {
            main: "#e26b27",
            secondary: "#2C2E2F",
            tertiary: "#ffc600",
        },
        loginScreen: {
            loginContainer: {
                background: "#fff",
            },
            formContainer: {
                background: "#fff",
            },
        },
        menuContainer: {
            background: "#e26b27",
            color: "#fff",
        },
        assetListHeading: {
            default: "#fee382",
            net: "#22C064",
        },
        background: {
            darkBackground: "#2C2E2F",
            mediumBackground: "#babfc3",
            lightBackground: "#e2e4e5",
        },
        border: {
            primary: "#e26b27",
            darkBorder: "#2C2E2F",
            mediumBorder: "#2C2E2F",
            lightBorder: "#e2e4e5",
        },
        tabButtons: {
            active: "#e26b27",
            activeText: "#fef0b8",
            default: "#e2e4e5",
            defaultText: "#2C2E2F",
        },
        text: {
            primary: "#1f1f1f",
            secondary: "#2C2E2F",
            darkText: "#2C2E2F",
            contrastText: "#fef0b8",
        },
        iconsColor: {
            primary: "#e26b27",
            secondary: "#2C2E2F",
        },
        success: {
            main: "#e26b27",
        },
        info: {
            main: "#007AFF",
        },
        warning: {
            main: "#ebc12b",
        },
        error: {
            main: "#EE315E",
        },
    },
    props: {
        MuiTooltip: {
            arrow: true,
        },
    },
    components: {
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: "#272727",
                },
            },
        },
    },
};

export default theme;
